export default __webpack_public_path__ + "static/02-c4efc1a53d0ff64b4b0268ac960f2ffa.jpg";